import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7f9d82e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-student-container" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View Student", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Student Details", -1))
const _hoisted_5 = {
  key: 0,
  class: "student-details"
}
const _hoisted_6 = { class: "detail-section" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Personal Information", -1))
const _hoisted_8 = { class: "detail-grid" }
const _hoisted_9 = { class: "detail-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First Name:", -1))
const _hoisted_11 = { class: "detail-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Last Name:", -1))
const _hoisted_13 = { class: "detail-section" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Address", -1))
const _hoisted_15 = { class: "detail-grid" }
const _hoisted_16 = { class: "detail-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Address:", -1))
const _hoisted_18 = { class: "detail-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "City:", -1))
const _hoisted_20 = { class: "detail-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "State:", -1))
const _hoisted_22 = { class: "detail-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "ZIP:", -1))
const _hoisted_24 = { class: "detail-section" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "School Information", -1))
const _hoisted_26 = { class: "detail-grid" }
const _hoisted_27 = { class: "detail-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "School:", -1))
const _hoisted_29 = { class: "detail-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Group:", -1))
const _hoisted_31 = { class: "detail-section" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Additional Information", -1))
const _hoisted_33 = { class: "detail-grid" }
const _hoisted_34 = { class: "detail-item full-width" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Needs:", -1))
const _hoisted_36 = { class: "needs-list" }
const _hoisted_37 = { class: "detail-item full-width" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Comments:", -1))
const _hoisted_39 = { class: "comments" }

import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { API_URL } from "../config";

interface Student {
  id: number;
  firstName: string;
  lastName: string;
  addressLine1: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zip?: string;
  phone?: string;
  birthday?: string;
  gender?: "male" | "female";
  weight?: number;
  ethnicity?: string;
  grade?: string;
  level?: string;
  studentType?: string;
  comments?: string;
  notes?: string;
  needs?: string;
  lng?: number;
  lat?: number;
  pickupLat?: number;
  pickupLng?: number;
  pickupAddress?: string;
  pickupNotes?: string;
  primarySchool?: {
    id: number;
    name: string;
  };
  group?: {
    id: number;
    name: string;
  };
  createdAt: Date;
  updatedAt: Date;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewStudentView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const student = ref<Student | null>(null);

const needsList = computed(() => {
  if (!student.value?.needs) return [];
  return student.value.needs.split(",").map((need: string) => need.trim());
});

const fetchStudent = async () => {
  try {
    const response = await fetch(`${API_URL}/students/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    if (response.ok) {
      student.value = await response.json();
    } else {
      console.error("Failed to fetch student details");
      alert("Failed to load student details");
    }
  } catch (error) {
    console.error("Error:", error);
    alert("An error occurred while fetching student details");
  }
};

const goBack = () => {
  router.push("/students");
};

const editStudent = () => {
  router.push(`/students/${route.params.id}/edit`);
};

onMounted(() => {
  fetchStudent();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _createVNode(_component_router_link, { to: "/students" }, {
        default: _withCtx(() => [
          _createTextVNode("Students")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _hoisted_3
    ]),
    _hoisted_4,
    (student.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("section", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", null, _toDisplayString(student.value.firstName), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", null, _toDisplayString(student.value.lastName), 1)
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("span", null, _toDisplayString(student.value.addressLine1), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("span", null, _toDisplayString(student.value.city), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", null, _toDisplayString(student.value.state), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("span", null, _toDisplayString(student.value.zip), 1)
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("span", null, _toDisplayString(student.value.primarySchool?.name || "Not assigned"), 1)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("span", null, _toDisplayString(student.value.group?.name || "Not assigned"), 1)
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(needsList.value, (need) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: need,
                      class: "need-tag"
                    }, _toDisplayString(need), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("p", _hoisted_39, _toDisplayString(student.value.comments || "No comments"), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", { class: "actions" }, [
      _createElementVNode("button", {
        onClick: goBack,
        class: "secondary-button"
      }, "Back to List"),
      _createElementVNode("button", {
        onClick: editStudent,
        class: "primary-button"
      }, "Edit Student")
    ])
  ]))
}
}

})